/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Col, Row, Tooltip } from "antd";
import { SelectFieldOptionGroup } from "../../../../../../atoms/FormFields/SelectFieldOptionGroup";
import {
  DeleteIcon,
  PlusIcon,
  ReverstIcon,
  TipIcon,
} from "../../../../../../atoms/CustomIcons";
import {
  InputField,
  InputNumberField,
} from "../../../../../../atoms/FormFields";
import { useAppSelector } from "../../../../../../config/hooks";

export default function MaterialList(props: any) {
  const {
    control,
    append,
    remove,
    fields,
    combineDropDown,
    watch,
    takeOffType,
    setValue,
  } = props;
  const material = watch("materials");
  const serviceFormData = useAppSelector(
    (state) =>
      state?.services?.serviceFormData as {
        data?: {
          materials?: { value: string; unit: string }[];
          category?: { value: string; unit: string }[];
        };
      }
  );
  const initQ: any = {
    manager: "",
  };

  const onAdd = () => {
    append(initQ);
  };

  const removeWeekTime = (ind: number) => {
    remove(ind);
  };

  const selectChange = (
    value: string | number | readonly string[],
    options: { value: string; label: string; color?: string; type: string },
    ind: number
  ) => {
    console.log("optionDat", options, value);
    if (options?.type === "material") {
      setValue(
        `materials.${ind}.unit_order`,
        "material_unit_per_measurement_unit"
      );
    } else if (options?.type === "category") {
      setValue(
        `materials.${ind}.unit_order`,
        "category_unit_per_measurement_unit"
      );
    }
  };

  const materialReverst = (ind: number) => {
    const materialUnit = material?.[ind]?.unit_order;
    if (materialUnit === "material_unit_per_measurement_unit") {
      setValue(
        `materials.${ind}.unit_order`,
        "measurement_unit_per_material_unit"
      );
    } else if (materialUnit === "measurement_unit_per_material_unit") {
      setValue(
        `materials.${ind}.unit_order`,
        "material_unit_per_measurement_unit"
      );
    } else if (materialUnit === "category_unit_per_measurement_unit") {
      setValue(
        `materials.${ind}.unit_order`,
        "measurement_unit_per_category_unit"
      );
    } else if (materialUnit === "measurement_unit_per_category_unit") {
      setValue(
        `materials.${ind}.unit_order`,
        "category_unit_per_measurement_unit"
      );
    }
  };

  return (
    <Card>
      <div className="card_top">
        <div className="card_left">
          <h4
            style={{
              marginBottom: "4px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            Materials
            <Tooltip
              title={
                <>
                  You can select a material category to define a broad group of
                  materials that may be used for this service based on customer
                  needs. When a category is selected, the manager will choose
                  the specific material during estimation or ordering. <br />
                  <br />
                  <b>Important:</b> Choose categories with materials of similar
                  size or unit, so the usage rate stays the same regardless of
                  which material is selected later.
                </>
              }
            >
              <Button className="proTipBtn">
                <TipIcon /> Pro tip
              </Button>
            </Tooltip>
          </h4>
          <p style={{ marginBottom: "16px" }}>
            Materials listed here are counted as direct costs for this service.
          </p>

          <Col span={24} className="task_list">
            <Row className="add_more">
              <Col flex={fields?.length > 0 ? "0 0 100%" : "0 0 100%"}>
                {fields?.length > 0 ? (
                  <>
                    {fields.map((item: any, ind: number) => (
                      <div className="add_material_wrapper" key={item.id}>
                        <div className="material_drop">
                          {ind === 0 && <label>Material</label>}
                          <SelectFieldOptionGroup
                            fieldName={`materials.${ind}.manager`}
                            label=""
                            control={control}
                            selectOption={combineDropDown}
                            iProps={{
                              placeholder: "Select material",
                              allowClear: true, // Move tagRender inside iProps if supported
                            }}
                            onSelectChange={(e, opt) =>
                              selectChange(e, opt, ind)
                            }
                          />
                        </div>
                        <div className="use_rate_box">
                          {ind === 0 && <label>Use rate</label>}
                          <InputNumberField
                            fieldName={`materials.${ind}.use_rate`}
                            label=""
                            control={control}
                            iProps={{
                              placeholder: "Enter use rate",
                            }}
                            defaultValue={0}
                            price
                          />
                        </div>
                        <div
                          className="mt_short"
                          style={{
                            marginTop: ind === 0 ? "16px" : 0,
                            fontSize: 15,
                            lineHeight: "20px",
                            fontWeight: 400,
                            color: "#151718",
                          }}
                        >
                          {material?.[ind]?.unit_order ===
                            "material_unit_per_measurement_unit" ||
                          material?.[ind]?.unit_order ===
                            "category_unit_per_measurement_unit" ? (
                            <>
                              {serviceFormData?.data?.materials?.find(
                                (e: { value: string }) =>
                                  e?.value === material?.[ind]?.manager
                              )?.unit ?? (
                                <Tooltip title="The unit will be set automatically once you select the actual material here or in the estimate">
                                  ...
                                </Tooltip>
                              )}{" "}
                              / {takeOffType}
                            </>
                          ) : (
                            <>
                              {takeOffType} /{" "}
                              {serviceFormData?.data?.materials?.find(
                                (e: { value: string }) =>
                                  e?.value === material?.[ind]?.manager
                              )?.unit ?? (
                                <Tooltip title="The unit will be set automatically once you select the actual material here or in the estimate">
                                  ...
                                </Tooltip>
                              )}
                            </>
                          )}
                        </div>
                        <div
                          className="reverst_icon"
                          style={{ marginTop: ind === 0 ? "20px" : "2px" }}
                        >
                          <Button
                            htmlType="button"
                            className="only_icon"
                            icon={<ReverstIcon />}
                            onClick={() => materialReverst(ind)}
                            style={{
                              width: 28,
                              height: 28,
                            }}
                          />
                        </div>
                        <div style={{ display: "none" }}>
                          <InputField
                            fieldName={`materials.${ind}.unit_order`}
                            defaultValue={
                              serviceFormData?.data?.materials?.some(
                                (e: { value: string }) =>
                                  e?.value === material?.[ind]?.manager
                              )
                                ? "material_unit_per_measurement_unit"
                                : "category_unit_per_measurement_unit"
                            }
                            label=""
                            control={control}
                            iProps={{
                              placeholder: "material unit ",
                            }}
                          />
                        </div>

                        <div
                          className="material_delete"
                          style={{ marginTop: ind === 0 ? "16px" : 0 }}
                        >
                          <Button
                            htmlType="button"
                            className="only_icon"
                            onClick={() => removeWeekTime(ind)}
                            icon={<DeleteIcon />}
                          />
                        </div>
                      </div>
                    ))}
                    <Col span={24}>
                      <Button
                        htmlType="button"
                        onClick={onAdd}
                        className="btn-sm"
                        icon={<PlusIcon />}
                      />
                    </Col>
                  </>
                ) : (
                  <div className="whenEmpty">
                    <h3> There are no materials </h3>
                    <p> Click “+” to add a material to this service. </p>
                    <Button
                      type="primary"
                      className="outlined-btn btn-sm"
                      icon={<PlusIcon style={{ color: "#151718" }} />}
                      onClick={onAdd}
                      style={{ marginBottom: 0 }}
                    >
                      Add material
                    </Button>
                  </div>
                )}
              </Col>
            </Row>
          </Col>
        </div>
      </div>
    </Card>
  );
}
